import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import "../facility/facility.scss";
import Page from "components/page/Page";
import { StatusCode } from "api/protocols";
import { useTranslation } from "react-i18next";
import axios, { CancelToken } from "axios";
import { GetCustomer } from "api/rpc/2024-04/facilityAdmin/customer/customer";
import { useAppDispatch } from "hooks/redux";
import CustomerTable from "elements/customer/CustomerTable";
import Search from "components/search/Search";
import { showError } from "redux/actions/ui";

interface IFilterState {
  search: string;
  limit: number;
  offset: number;
}

const TABLE_LIMIT = 100;

export default function CustomerTypeRoster(props: any) {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();

  const [customers, setCustomers] = useState(undefined);

  const [filter, setFilter] = useState<IFilterState>({
    search: "",
    offset: 0,
    limit: TABLE_LIMIT,
  });

  // Search Customers
  useEffect(() => {
    const source = axios.CancelToken.source();

    void loadCustomers(source.token);

    return () => {
      source.cancel();
    };
  }, [filter.search, filter.offset]);

  async function loadCustomers(token?: CancelToken) {
    if (customers !== undefined) {
      setCustomers(undefined);
    }

    const customerType = [];
    customerType.push(Number(id));

    const customerRes = await GetCustomer(
      {
        "default-address-line": true,
        limit: TABLE_LIMIT,
        offset: filter.offset,
        search: filter.search,
        customer_type: customerType,
      },
      token ? false : true,
      token,
    );

    if (token && token.reason) {
      return;
    }

    if (customerRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading customers"))); // TODO: Translation
    }

    setCustomers(customerRes.status !== StatusCode.OK ? [] : customerRes.data);
  }

  function handleTableNavigation(direction: "prev" | "next") {
    switch (direction) {
      case "prev": {
        setFilter(prev => ({ ...prev, offset: filter.offset - TABLE_LIMIT }));
        break;
      }
      case "next": {
        setFilter(prev => ({ ...prev, offset: filter.offset + TABLE_LIMIT }));
        break;
      }
      default:
        return;
    }
  }

  return (
    <Page
      title={"Customer Roster"}
      breadcrumbs={[
        {
          prefix: true,
          label: "Customer Types",
          url: "/admin/settings/customer_types",
        },
      ]}
    >
      <div className="flex-grow mb-3.5">
        <Search
          placeholder={t("secure.facility.customer.main.customers.003")}
          historyKey={"search_customers_table"}
          searchCallback={searchValue => setFilter(prev => ({ ...prev, search: searchValue, offset: 0 }))}
        />
      </div>

      <CustomerTable
        customers={customers}
        onClick={customer => history.push("/admin/customers/" + String(customer.id) + "/profile")}
        tableLimit={TABLE_LIMIT}
        tableOffset={filter.offset}
        handlePagination={direction => handleTableNavigation(direction)}
      />
    </Page>
  );
}
